import { LegalLayout, usePublicSettings } from "./LegalLayout";

export default function MentionsLegales() {
  const settings = usePublicSettings();
  return (
    <LegalLayout title="Mentions légales" testid="mentions-legales-page">
      <section>
        <h2>Éditeur du site</h2>
        <p>
          <strong>MARY SERVICES</strong><br />
          Société par actions simplifiée (SAS) — créée le 21 septembre 2022<br />
          Siège social : La Valentinière, 61210 Giel-Courteilles, France<br />
          SIREN : 919 479 261 — SIRET (siège) : 919 479 261 00019<br />
          Numéro de TVA intracommunautaire : FR04919479261<br />
          Code APE / NAF : 8559B
        </p>
        <p>
          Dirigeant : Julien MARY<br />
          Directeur de la publication : Julien MARY
        </p>
        <p>
          Contact : <a className="text-forest underline underline-offset-2" href={`tel:${(settings.phone || "").replace(/\s/g, "")}`}>{settings.phone}</a>
          {" — "}
          <a className="text-forest underline underline-offset-2" href={`mailto:${settings.email}`}>{settings.email}</a>
        </p>
      </section>

      <section>
        <h2>Hébergement</h2>
        <p>
          Ce site est hébergé via la plateforme Emergent (emergent.sh). Les données sont hébergées au sein de
          l'infrastructure cloud associée.
        </p>
      </section>

      <section>
        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble des contenus présents sur le site mary-services.com (textes, photographies, logo, éléments
          graphiques) est la propriété exclusive de MARY SERVICES, sauf mention contraire. Toute reproduction,
          représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.
        </p>
      </section>

      <section>
        <h2>Responsabilité</h2>
        <p>
          MARY SERVICES s'efforce d'assurer l'exactitude des informations diffusées sur ce site, sans pouvoir en
          garantir l'exhaustivité ni l'absence d'erreurs. MARY SERVICES ne saurait être tenue responsable des
          dommages directs ou indirects résultant de l'utilisation du site.
        </p>
      </section>

      <section>
        <h2>Droit applicable</h2>
        <p>
          Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français
          seront seuls compétents.
        </p>
      </section>
    </LegalLayout>
  );
}
